import { faTimesCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import GoogleAdsense from 'app/components/layouts/Ads/GoogleAdsense';
import TaskButtons from 'app/components/tests/layouts/TaskButtons';
import { checkIsCorrect, minuteTest } from 'app/utils/test';
import * as categoryConst from 'app/constants/categories';
import { Question, Group, Passage } from 'types/test';
import { AppStoreState } from 'app/redux/store';
import Timer from 'app/components/tests/Timer';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import dynamic from "next/dynamic";

const ModalChangeTime = dynamic(() => import("app/components/tests/modal/ModalChangeTime"), { ssr: false });

interface QuestionListProps {
  activeQuestion: (question: Question) => void;
  handleExamScore: () => void;
  numberQuestionDone: number;
  passagesOfUser: Passage[];
  initDataTest: () => void;
}

const QuestionList = ({ activeQuestion, handleExamScore, numberQuestionDone, passagesOfUser, initDataTest }: QuestionListProps) => {
  const { t } = useTranslation();
  const [timeTest, setTimeTest] = useState<Record<string, any>>({});
  const { process, test, groupQuestions, result } = useSelector((state: AppStoreState) => state.test);

  const handleChangeTimer = (data: any, isTimeUp: boolean) => {
    if (process === 'complete') setTimeTest({ ...data, is_time_up: isTimeUp });
  };

  const getQuestions = (): Question[] => {
    const questions: Question[] = [];
    const resultQuestion = result?.group_questions || [];

    groupQuestions?.forEach((group: Group, groupIndex: number) => {
      const groupClone = { ...group };

      if (resultQuestion[groupIndex]) {
        groupClone.list_question = (groupClone.list_question || []).map((question, qIndex) => {
          const resultQ = resultQuestion[groupIndex].list_question[qIndex];
          const { isCorrect } = checkIsCorrect({ ...question, result: resultQ.result });

          return {
            ...question,
            correct: isCorrect,
            notCorrect: question.answer ? !isCorrect : false
          };
        });
      }

      if (Number(group.number_question) > 1) {
        groupClone.list_question = (groupClone.list_question || []).map((question) => ({
          ...question,
          group_question_number: group.number_question
        }));
      }

      questions.push(...(groupClone.list_question || []));
    });

    return questions;
  };

  const renderQuestions = () => getQuestions().map((question: Question) => {
    const startNumber = question.number! - Number(question.group_question_number) + 1;
    const prefix = startNumber < question.number! ? `${startNumber} - ` : '';

    return (
      <span
        key={question.id}
        className={`position-relative ${question.answer ? 'q-active' : ''}`}
        onClick={() => activeQuestion(question)}
        style={{ minWidth: prefix ? 65 : 0 }}
      >
        {question.correct && (
          <FontAwesomeIcon className="text-success icon-result-question position-absolute" icon={faCheckCircle} />
        )}
        {question.notCorrect && (
          <FontAwesomeIcon className="text-danger icon-result-question position-absolute" icon={faTimesCircle} />
        )}
        {prefix}{question.number}
      </span>
    );
  });

  return (
    <div className="right fl">
      <div className="blockRight">
        <div className="d-flex flex-wrap border-bottom">
          <div className="col-6 text-center py-3 border-right">
            <div>{t('tests.number_question_done')}</div>
            <span className="font-weight-bold">
              {numberQuestionDone}/{test.questions_count}
            </span>
          </div>
          <div className="col-6 text-center py-3">
            <div>{t('tests.time_remain')}</div>
            <Timer
              timer={minuteTest(test.category_id, test.questions_count)}
              process={process}
              handleExamScore={handleExamScore}
              changeTimer={handleChangeTimer}
            />
            <ModalChangeTime
              dataTest={test}
              timeTest={timeTest}
              isOpen={Object.keys(timeTest).length > 0}
              passagesOfUser={passagesOfUser}
              onConfirm={initDataTest}
              onClose={() => setTimeTest({})}
            />
          </div>
        </div>

        <div className="listNumber">
          <div className='mt-2 text-center text-info'>{t('tests.jump_question')}</div>
          {test.category_id === categoryConst.IELT_WRITE && <TaskButtons />}
          <div className="blockQuestion d-flex justify-content-center flex-wrap my-1">
            {renderQuestions()}
          </div>
          <div className="d-flex justify-content-center flex-wrap mt-2">
            <GoogleAdsense width="336px" height="280px" dataSlot="4537753411" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionList;
